import React, { useState } from "react";
import { Row, Col, Container, Button, Alert } from "reactstrap";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import withRouter from "../../components/Common/withRouter";
import { useTranslation } from "react-i18next";
import { loginAction } from "src/store/auth/saga";
import { useAppSelector } from "src/store";
import avatar1 from "../../assets/images/logo-sm.svg";
import { Formik } from "formik";
import * as Yup from "yup";
import "./style.scss";
import GetInput from "src/components/Form/GetInput";
import { setUser } from "src/store/auth/authSlice";
import { getLanguages } from "src/store/languages/saga";
import { useNavigate } from "react-router";
import Loader from "src/components/Loader";
import Layout from "./Layout";

const Login = (props: any) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const loader = useAppSelector((s) => s.loading.loading);
  const [error, setError] = useState<string>();
  const navigate = useNavigate();
  const a = localStorage.getItem("language");
  return (
    <React.Fragment>
      <Layout
        title={t("Login.Heading", "Tekrar hoş geldin").toString()}
        subtitle={t("Login.Sub", "Devam etmek için giriş yapın").toString()}
      >
        {loader && <Loader />}
        <Formik
          initialValues={{
            Email: "",
            Password: "",
          }}
          onSubmit={(values) => {
            dispatch(
              loginAction({
                payload: {
                  onSuccess: (message, payload) => {
                    dispatch(setUser(payload));
                    dispatch(getLanguages());
                    navigate("/dashboard");
                  },
                  onError: (message) => {
                    console.log(message, "meesage");
                    setError(message);
                  },
                },
                body: {
                  UserName: values.Email,
                  Password: values.Password,
                },
              })
            );
          }}
          validationSchema={Yup.object().shape({
            Email: Yup.string()
              .required(t("Validation.Required").toString())
              .email(t("Validation.Email").toString()),
          })}
        >
          {({ handleSubmit }) => (
            <Row className="mt-4">
              {error && (
                <Col md={12}>
                  <Alert color="danger">{error}</Alert>
                </Col>
              )}
              <GetInput
                inputprop={{
                  field: "Email",
                  label: t("Authentication.Email").toString(),
                  type: "email",
                }}
              />
              <GetInput
                inputprop={{
                  field: "Password",
                  label: t("Authentication.Password").toString(),
                  type: "password",
                }}
              />
              <a
                href="/forgot-password"
                className="text-muted"
                style={{ textAlign: "right", fontSize: 10 }}
              >
                {t("Login.ForgotPassword").toString()}
              </a>
              <Col md={12}>
                <Button
                  className="w-100 mt-2"
                  color="primary"
                  type="submit"
                  style={{ fontSize: 12, height: 45 }}
                  onClick={() => handleSubmit()}
                >
                  {t("Login.LoginButton")}
                </Button>
              </Col>
            </Row>
          )}
        </Formik>
      </Layout>
    </React.Fragment>
  );
};

export default withRouter(Login);
Login.propTypes = {
  history: PropTypes.object,
};
